export class ChangeLessee {
  constructor({
    id = 0,
    orderID = 0,
    dealerID = 0,
    changeLesseeDetails = {},
    formerCustomerID = 0,
    newCustomerID = 0,
    guid = "00000000-0000-0000-0000-000000000000",
    status = "",
    _lesseChangeGuidURL = ""
  } = {}) {
    this.id = id;
    this.orderID = orderID;
    this.dealerID = dealerID;
    this.changeLesseeDetails = {};
    this.formerCustomerID = 0;
    this.newCustomerID = 0;
    this.changeLesseeDetails = changeLesseeDetails;
    this.formerCustomerID = formerCustomerID;
    this.newCustomerID = newCustomerID;
    this.guid = guid;
    this.dealerID = dealerID;
    this.status = status;
    this._lesseChangeGuidURL = _lesseChangeGuidURL;
  }
}

export function createChangeLessee(data) {
  return Object.freeze(new ChangeLessee(data));
}
